import { Dialog, DialogContent, DialogTitle, styled } from "@mui/material";

interface DialogBoxProps {
  status?: string;
}

export const DialogBox = styled(Dialog)<DialogBoxProps>(({ status }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "8px",
    padding: "16px",
    minWidth: status === "hide-icon" ? "auto" : "520px",
    // Add media query for smaller screens
    "@media (max-width: 600px)": {
      minWidth: "calc(100vw - 32px)", // Take up almost full screen width
      maxWidth: "100%",
      margin: "16px",
    },
  },
}));

export const DialogBoxTitle = styled(DialogTitle)({
  "&.MuiDialogTitle-root": {
    fontFamily: "Inter",
    padding: "0px 0px 12px 0px",
    fontSize: "24px",
    fontWeight: "700",
    lineHeight: "24.2px",
    textTransform: "capitalize",
    // Add media query for smaller screens
    "@media (max-width: 600px)": {
      fontSize: "20px",
    },
  },
});

export const DialogBoxContent = styled(DialogContent)({
  "&.MuiDialogContent-root": {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "400",
    color: "#666666",
    padding: "16px 0px 8px 0px",
    textAlign: "center",
  },
});
